import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, map } from 'rxjs/operators';
import { Action } from 'redux';
import { NewTrack } from '../action-creators';
import AppState from '../../state';
import { CreateAssetSuccess } from '../../assets/action-creators';
import { CREATE_ASSET_SUCCESS } from '../../assets/actions';
import SimpleTrack from '../../../../../../common/types/release/simple-track';
import { createNewTrack } from '@webapp/utils/tracks/create-new-track';
import SimpleArtist from '@common/types/artist/simple-artist';

/**
 *
 * This effect creates a new Track locally after a successful upload.
 *
 */

export const newTracksAfterAssetEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, CreateAssetSuccess>(CREATE_ASSET_SUCCESS),
    withLatestFrom(state$),
    filter(([action, state]) => !!state.artist.active?.id && action.assetType === 'audio'),
    map(([action, state]) => {

      const track: Partial<SimpleTrack> = createNewTrack(
        action.response.id,
        state.release.release?.id as string,
        state.release.release?.type || 'single',
        action.fileName.substring(0, action.fileName.lastIndexOf('.')) || action.fileName,
        state.artist.active?.name as string,
        action.fileName,
        action.response.url,
        action.metadata
      );

      const artist = state.artist.active as SimpleArtist;

      return new NewTrack(track, artist);
    })
  );